import Icon from '@/componentsDS/Icon/Icon';
import Tooltip from '@/componentsDS/Tooltip';
import PropTypes from 'prop-types';

// Label above DS inputs (Input, InputDropdownSelect): required asterisk + optional info tooltip
const InputLabel = ({ id, className = 'DS__input-label', label, required, labelInfoText }) => (
	<label htmlFor={id} className={className} data-testid="input-field-label">
		{required && <span className="DS__input-label__asterisk">*</span>}
		{label}
		{labelInfoText && (
			<Tooltip id={labelInfoText} content={labelInfoText}>
				<Icon name="information-circle" style="solid" size="small" />
			</Tooltip>
		)}
	</label>
);

export default InputLabel;

InputLabel.propTypes = {
	id: PropTypes.string,
	className: PropTypes.string,
	label: PropTypes.node,
	required: PropTypes.bool,
	labelInfoText: PropTypes.string,
};
